exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/app/item-view/item-view.component.css
// module id = ../../../../../src/app/item-view/item-view.component.css
// module chunks = main